import axios from "axios";
import url from "./urlServiceConfig";
import { addToast } from "../../helpers";

axios.defaults.baseURL = url.baseUrl;

function responseInterceptor(response) {
  if (response.data?.StatusCode && response.data?.StatusCode !== "Success" ) {
    addToast.error(response.data?.StatusMessage || "Error", {
      toastId: "service-error",
    });
    throw new Error(response.data?.StatusMessage || "Error");
  }
  return response.data;
}

function errorInterceptor(error) {
  if (error.response.status === 401) {
    localStorage.clear();
    window.location.reload();
  }
  return Promise.reject(error);
}

axios.interceptors.response.use(responseInterceptor, errorInterceptor);

export const storage = axios.create({
  baseURL: url.baseUrl,
});

export const delegation = axios.create({
  baseURL: url.baseUrl,
});

delegation.interceptors.response.use(responseInterceptor, errorInterceptor);
